




























































































































import {
  BSidebar,
  BSpinner,
  BForm,
  BButton,
  BFormDatepicker,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormFile,
} from "bootstrap-vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import { BilanActivite, UpdateBilanActiviteModel } from "@/api/models/bilansActivite/bilanActivite";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";

@Component({
  components: {
    BSidebar,
    BCol,
    BSpinner,
    BButton,
    BFormInput,
    BForm,
    BFormGroup,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    SearchableVueSelect
  },
})
export default class UpdateBilanActivite extends Vue {
  @Prop({ required: true, type: Boolean }) isUpdateBilanActiviteSidebarActive!: boolean;
  @Prop({ required: true }) bilanActiviteId!: string;

  loading = false;
  required = required;
  loadingBilanActivite = false;
  isAddFileEnabled = false;

  
  listTypesBilans: any[] = [];
  totalCountTypesBilans = 0;

  bilanActivite: UpdateBilanActiviteModel = {};

 async created() {
  await this.loadTypesBilans(),

    await this.$http.myressif.entreprises
      .getBilanActiviteById(
        this.$route.params.id,
        this.bilanActiviteId
      )
      .then((res: BilanActivite) => {
        this.bilanActivite = res;
        this.loadingBilanActivite = true;
      });
  }

  async loadTypesBilans() {
    await this.$http.myressif.parametres
      .getByNom("entreprise_type_bilan_activite")
      .then((res: any) => {
        let typesBilans = JSON.parse(res.valeur);
        typesBilans.forEach((itm :any) => {
          let bilan = [...Array(5)].map(
            (a, b) => itm + " " + (new Date().getFullYear() - 1 + b)
          );
          this.listTypesBilans.push(...bilan);
        });
      });
  }

  resetForm() {
    this.bilanActivite = {};
  }

  async submit() {
    this.loading = true;
    await this.$http.myressif.entreprises
      .updateBilanActiviteEntreprise(
        this.$route.params.id,
        this.bilanActivite.id,
        this.bilanActivite
      )
      .then(
        async (response: any) => {
          successAlert.fire({
            timer: 3500,
            title: "Modification du bilan d'activite",
            text: "Bilan d'activité modifié avec succès",
          });
        },
        (error: any) => {
          if (
            error?.response?.data?.errors &&
            Object.keys(error.response.data.errors).length
          ) {
            errorAlert.fire({
              text: error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ],
            });
          } else {
            errorAlert.fire({
              text: error?.response?.data?.detail ?? error.message,
            });
          }
        }
      )
      .finally(() => {
        this.$emit("refresh-bilans-activite");
        this.$emit("update:is-update-bilan-activite-sidebar-active", false);
        this.loading = false;
        this.isAddFileEnabled = false;
      });
  }
}
